export default {"src":"/_next/static/media/new.9e968dfe.svg","height":61,"width":61,"blurWidth":0,"blurHeight":0};